<template>
  <div>
    <p class="admin-page-description">
      Regras de negócio (BRG) que definem como os pagamentos da
      instituição funcionam: dia de vencimento, splits entre recebedores,
      métodos de pagamento aceitos e produtos. Crie, edite e desabilite
      regras por curso, turma, kind ou período letivo.
    </p>
    <create-or-update
      v-if="showCreateOrUpdateComponent"
      @edit-business-rule-group="updateShowCreateOrUpdateComponent"
      :rule="rule"
    />
    <list
      v-else
      @edit-business-rule-group="updateShowCreateOrUpdateComponent"
      @selected-business-rule-group="setSelectedBusinessRuleGroup"
    />
  </div>
</template>

<script>
import List from './List';
import CreateOrUpdate from './CreateOrUpdate';

export default {
  components: {
    List,
    CreateOrUpdate,
  },
  data() {
    return {
      showCreateOrUpdateComponent: false,
      rule: null,
    };
  },
  methods: {
    updateShowCreateOrUpdateComponent(visibility) {
      this.showCreateOrUpdateComponent = visibility;
      if (!visibility) {
        this.clearSelectedRule();
      }
    },
    setSelectedBusinessRuleGroup($event) {
      this.rule = $event;
      this.updateShowCreateOrUpdateComponent(true);
    },
    clearSelectedRule() {
      this.rule = null;
    },
  },
};
</script>
